import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import fnolTheme from '@fnol/library/src/themes/fnolTheme';
import HouseApp from './components/HouseApp';

// returns HouseApp (the app entry file) and providers

function App() {
    return (
        <>
            <CssBaseline />
            <ThemeProvider theme={fnolTheme}>
                <HouseApp />
            </ThemeProvider>
        </>
    );
}

export default App;
